import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../service/Api";
import { User, PaginatedUsersResponse } from "./types";


export const fetchUsers = createAsyncThunk<
  User[],
  void,
  { rejectValue: string }
>("users/fetchAll", async (_, { rejectWithValue }) => {
  try {
    const res = await apiService.get<PaginatedUsersResponse>("/api/authentication/users/?page_size=1000000");
    return res.data.results;
  } catch (error) {
    const errorDetail = (error as { response?: { data?: { detail?: string } } })
      ?.response?.data?.detail;
    return rejectWithValue(errorDetail || "Failed to fetch users");
  }
});


export const createUser = createAsyncThunk<
  User,
  Partial<User>,
  { rejectValue: string }
>("users/create", async (data, { rejectWithValue }) => {
  try {
    const res = await apiService.post<User>("/api/authentication/users/", data);
    return res.data;
  } catch (error) {
    const errorDetail = (error as { response?: { data?: { detail?: string } } })
      ?.response?.data?.detail;
    return rejectWithValue(errorDetail || "Failed to create user");
  }
});


export const updateUser = createAsyncThunk<
  User,
  { id: number; data: Partial<User> },
  { rejectValue: string }
>("users/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await apiService.patch<User>(
      `/api/authentication/users/${id}/`,
      data
    );
    return res.data;
  } catch (error) {
    const errorDetail = (error as { response?: { data?: { detail?: string } } })
      ?.response?.data?.detail;
    return rejectWithValue(errorDetail || "Failed to update user");
  }
});



export const deleteUser = createAsyncThunk<
  number,
  number,
  { rejectValue: string }
>("users/delete", async (id, { rejectWithValue }) => {
  try {
    await apiService.delete(`/api/authentication/users/${id}/`);
    return id; 
  } catch (error) {
    const errorDetail = (error as { response?: { data?: { detail?: string } } })
      ?.response?.data?.detail;
    return rejectWithValue(errorDetail || "Failed to delete user");
  }
});
